// 规范文档： http://112.124.122.87:8090/pages/viewpage.action?pageId=3313300
// 408 页面加载超时
// 404 打包资源加载错误
// 415 非打包资源加载错误

// 599 全局抛错 可能阻断页面js
// 598 打印的error，一般来自第三方
// 597 异步抛错
// 596 Vue组件内部捕获的错误
// 595 接口catch error

// 用于对应日志的logtype
var logTypesMatchs = {
  'window.onerror': 'JSError',
  'source.error': 'sourceError',
  'console.error': 'JSError',
  unhandledrejection: 'JSError',
  'vue.errorHandler': 'JSError',
  APIError: 'JSError'
}

var cacheFetched = []

var itemStroageKey = '__catch_error_cache__'

try {
  const storageFetched = JSON.parse(
    window.sessionStorage.getItem(itemStroageKey)
  )
  if (Array.isArray(storageFetched)) {
    cacheFetched = storageFetched
  }
} catch (e) {
  cacheFetched = []
}

function wrapCallback(callback, config) {
  var configStr = JSON.stringify(config)
  if (cacheFetched.includes(configStr)) return
  cacheFetched.push(configStr)

  try {
    window.sessionStorage.setItem(itemStroageKey, JSON.stringify(cacheFetched))
  } catch (e) {
    console.log(e)
  }
  return callback(config)
}

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

// 因为& 和 # 在上传日志的时候，会被切断，所以需要处理下
function formatLogURL(res) {
  if (typeof res === 'object') {
    res = JSON.stringify(res)
  }
  return res.replace(/#/gi, '井').replace(/&/gi, '¥')
}

// 统一上传格式
function getError({ title, type, stack, code, ...other }) {
  if (!stack) {
    stack = 'no stack'
  }
  var message = formatLogURL(
    isObject(stack)
      ? Object.assign(stack, { type }, other)
      : Object.assign({ stack, type }, other)
  )
  const level = [404, 599, 596].indexOf(code) > -1 ? 'error' : 'warn'
  return {
    title: formatLogURL(title),
    message,
    level,
    code: code,
    logType: logTypesMatchs[type],
    href: formatLogURL(window.location.href)
  }
}

function include(message, be) {
  return (
    message && typeof message.indexOf === 'function' && message.indexOf(be) > -1
  )
}

// 处理window.error 和 js/css/img error
function catchWindowError(callback) {
  window.addEventListener(
    'error',
    function(event) {
      try {
        if (!event) return

        var target = event.target
        var isScriptElement = target instanceof HTMLScriptElement
        var isLinkElement = target instanceof HTMLLinkElement
        var isImageElement = target instanceof HTMLImageElement
        var isElementTarget = isScriptElement || isLinkElement || isImageElement

        if (!isElementTarget) return // js error在window.error处理

        if (event.type !== 'error') return // 排除cancel

        // 排除空的标签，在接口未返回前很常见，因为取出来的src是页面链接，所以采用indexof outerHtml来搞
        if (
          isImageElement &&
          target.outerHTML &&
          target.outerHTML.indexOf(' src=""') > -1
        )
          return

        var errorUrl = target.src || target.href

        if (include(errorUrl, 'logstores/frontend/track')) return // 日志上传失败不处理，猜测可能被拦截

        wrapCallback(
          callback,
          getError({
            title: 'load ' + errorUrl + ' fail',
            code: errorUrl.indexOf('//static') > -1 ? 404 : 415,
            type: 'source.error',
            stack: event.error ? event.error : undefined
          })
        )
      } catch (e) {
        console.log('获取错误栈失败', e)
      }
    },
    true
  )

  window.onerror = function(message, source, lineno, colno, error) {
    if (window.ignoreError) {
      window.ignoreError = false
      return
    }

    if (include(message, 'Script error')) return // 只有script error 不上报，没意义

    wrapCallback(
      callback,
      getError({
        title: message + ' at ' + source + ':' + lineno + ':' + colno,
        type: 'window.onerror',
        stack: error && error.stack ? error.stack : 'no stack',
        code: 599
      })
    )
  }
}

// 兜console.error
function catchConsoleError(callback) {
  console.error = (function(origin) {
    return function(info) {
      var params = Array.prototype.slice.call(arguments).join('\r\n')
      wrapCallback(
        callback,
        getError({
          title: 'console.error at ' + info,
          type: 'console.error',
          stack: params,
          code: 598
        })
      )
      origin.call(console, info)
    }
  })(console.error)
}

function catchAsyncError(callback) {
  window.addEventListener('unhandledrejection', function(event) {
    try {
      var stack = event.reason && event.reason.stack
      var title = stack
      if (stack) {
        title = stack.split('\n')[0]
      }
      if (include(title, 'Request aborted')) return // 请求中止不上报，charle开启小乌龟，请求接口时刷新可以重现
      if (include(title, 'Network Error')) return // 网络错误不上报

      wrapCallback(
        callback,
        getError({
          title: title || 'unhandledrejection',
          type: 'unhandledrejection',
          stack: stack || event.reason,
          code: 597
        })
      )
    } catch (e) {
      console.log('catchAsyncError fail', e)
    }
  })
}

function catchVueError(callback, Vue) {
  if (!Vue) return
  Vue.config.errorHandler = function(error, vm, info) {
    if (!error) return

    var type = 'vue.errorHandler'
    var metaData = {
      info: info
    }

    if (typeof error === 'object') {
      metaData.message = error && error.message
      metaData.stack = error && error.stack
    }

    if (isObject(vm)) {
      metaData.component = vm._isVue
        ? typeof vm.$options === 'object' &&
          (vm.$options.name || vm.$options._componentTag)
        : vm.name
      metaData.propsData = vm.$options.propsData
    }

    wrapCallback(
      callback,
      getError({
        title: metaData.component + '@' + info,
        type,
        stack: metaData,
        code: 596
      })
    )
  }
}

const isSpiderRequest = (ua = window.navigator.userAgent) => {
  try {
    return (
      ua.toLowerCase().indexOf('spider') > -1 ||
      ua.toLowerCase().indexOf('bingpreview') > -1 || // 必应预览
      ua.toLowerCase().indexOf('baiduboxapp') > -1 // 手百
    )
  } catch (e) {
    console.log(`isSpiderRequest`, e)
    return false
  }
}

const addAxiosCatchErrorInterceptors = (callback, axios) => {
  return axios.interceptors.response.use(
    res => {
      return res
    },
    err => {
      if (err && err.config) {
        const { url, params, headers, data, method } = err.config
        wrapCallback(
          callback,
          getError({
            title: url,
            type: 'APIError',
            stack: err,
            code: 595,
            config: { url, params, headers, data, method }
          })
        )
      }
      return Promise.reject(err)
    }
  )
}

// 统一入口
// 如果是SSR 需要在页面之前引入，这个时候没有Vue，需要自己处理，参考headScripts挂在windows上，再在客户端渲染入口调用
function catchError(callback, Vue) {
  catchWindowError(callback)
  catchConsoleError(callback)
  catchAsyncError(callback)
  catchVueError(callback, Vue)
}

exports.catchWindowError = catchWindowError
exports.catchConsoleError = catchConsoleError
exports.catchAsyncError = catchAsyncError
exports.catchVueError = catchVueError
exports.catchError = catchError
exports.formatLogURL = formatLogURL
exports.isSpiderRequest = isSpiderRequest
exports.addAxiosCatchErrorInterceptors = addAxiosCatchErrorInterceptors
